import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TelemetryService {
  appInsights: ApplicationInsights;

  constructor() { 

    let key = environment.appInsights.instrumentationKey;
    
    if (!key) {
      console.warn('Application Insights instrumentation key is not set for this environment. Telemetry will not be sent.');
    }

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: key,
        enableAutoRouteTracking: true,
      }
    });

    this.appInsights.loadAppInsights();
  }

  /// Manually log a page view with optional name and URL parameters
  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({ name, uri: url });
  }

  /// Log a custom event with optional properties
  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  /// Log an exception with optional severity level and properties
  logException(exception: Error, severityLevel?: number, properties?: { [key: string]: any }) {
    this.appInsights.trackException({ exception, severityLevel }, properties);
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message}, properties);
  }
}
